import React, { Component } from 'react';
import { Card, Col, Row, notification } from 'antd';
import { ApexBotForm } from './ApexForm';
import { OdysseyBotForm } from './OdysseyForm';
import { MakoBotForm } from './MakoForm';
import { inject, observer } from 'mobx-react';

@inject('store')
@observer
export class NewBotView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedBot: null,
            loading: true,
            error: false,
            busy: false
        };
    }

    async createApexBot(values) {
        this.setState({ busy: true });
        values.api_key = values.api_key.trim();
        values.api_secret = values.api_secret.trim();

        try {
            await this.props.store.botStore.createBot(values);
            notification.success({
                message: 'Bot Created',
                description: 'Attach a subscription to start trading'
            });
            this.props.history.push(`/a/bots`);
        } catch (e) {
            notification.error({
                message: 'Error Creating Bot',
                description: e.message
            });
        }
    }

    async createOdysseyBot(values) {
        this.setState({ busy: true });
        values.api_key = values.api_key.trim();
        values.api_secret = values.api_secret.trim();

        try {
            await this.props.store.botStore.createOdysseyBot(values);
            notification.success({
                message: 'Bot Created',
                description: 'Attach a subscription to start trading.'
            });
            this.props.history.push(`/a/bots`);
        } catch (e) {
            notification.error({
                message: 'Error Creating Bot',
                description: e.message
            });
        }
    }

    async createMakoBot(values) {
        this.setState({ busy: true });
        values.api_key = values.api_key.trim();
        values.api_secret = values.api_secret.trim();

        try {
            await this.props.store.botStore.createMakoBot(values);
            notification.success({
                message: 'Bot Created',
                description: 'Attach a subscription to start trading.'
            });
            this.props.history.push(`/a/bots`);
        } catch (e) {
            notification.error({
                message: 'Error Creating Bot',
                description: e.message
            });
        }
    }

    render() {
        if (!this.state.selectedBot) {
            return (
                <Row gutter={24} type="flex" justify="center">
                    <Col md={{ span: 8 }}>
                        <div
                            className="bot-selector apex"
                            onClick={() => this.setState({ selectedBot: 'apex' })}
                        >
                            <div className="overlay" />
                            <div className="bot-name">APEX</div>
                            <div className="bot-description">Spot Trading</div>
                            <div className="bot-exchanges">
                                <img src="/exchanges/binance.png" alt="binance logo" />
                                <img src="/exchanges/kucoin.png" alt="kucoin logo" />
                                <img src="/exchanges/kraken.png" alt="kraken logo" />
                            </div>
                        </div>
                    </Col>

                    {/* <Col md={{ span: 8 }}>
                        <div
                            className="bot-selector odyssey"
                            onClick={() => this.setState({ selectedBot: 'odyssey' })}
                        >
                            <div className="overlay" />
                            <div className="bot-name">ODYSSEY</div>
                            <div className="bot-description">Margin Trading</div>
                            <div className="bot-exchanges">
                                <img src="/exchanges/bybit.png" alt="bybit logo" />
                            </div>
                        </div>
                    </Col> */}

                    <Col md={{ span: 8 }}>
                        <div
                            className="bot-selector odyssey"
                            onClick={() => this.setState({ selectedBot: 'mako' })}
                        >
                            <div className="overlay" />
                            <div className="bot-name">MAKO</div>
                            <div className="bot-description">Market Making</div>
                            <div className="bot-exchanges">
                                <img src="/exchanges/bybit.png" alt="bybit logo" />
                            </div>
                        </div>
                    </Col>
                </Row>
            );
        }

        if (this.state.selectedBot === 'apex') {
            return (
                <Card title="Create Apex Bot" bordered={false}>
                    <ApexBotForm onSubmit={this.createApexBot.bind(this)} busy={this.state.busy} />
                </Card>
            );
        }

        // if (this.state.selectedBot === 'odyssey') {
        //     return (
        //         <Card title="Create Odyssey Bot" bordered={false}>
        //             <OdysseyBotForm
        //                 onSubmit={this.createOdysseyBot.bind(this)}
        //                 busy={this.state.busy}
        //             />
        //         </Card>
        //     );
        // }

        if (this.state.selectedBot === 'mako') {
            return (
                <Card title="Create Mako Bot" bordered={false}>
                    <MakoBotForm onSubmit={this.createMakoBot.bind(this)} busy={this.state.busy} />
                </Card>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bots/New/index.js